import React from 'react';

interface WaveformVisualizerProps {
  isPlaying: boolean;
  barCount?: number;
  height?: number;
}

export const WaveformVisualizer: React.FC<WaveformVisualizerProps> = ({
  isPlaying,
  barCount = 36,
  height = 38,
}) => {
  const bars = Array.from({ length: barCount }, (_, i) => i);

  return (
    <div
      className="flex items-center gap-0.5 h-10 px-2 select-none overflow-hidden"
      style={{ height }}
    >
      {bars.map((index) => {
        // Generate pseudo-random bar heights based on wave curve
        const baseHeight = Math.sin((index / barCount) * Math.PI) * 70 + 20;
        const animationDelay = (index * 0.05).toFixed(2);
        const dynamicHeight = isPlaying
          ? `${Math.max(15, baseHeight + (index % 5) * 8)}%`
          : `${Math.max(15, baseHeight * 0.6)}%`;

        return (
          <div
            key={index}
            className={`w-1 rounded-full transition-all duration-150 ${
              isPlaying
                ? 'bg-gradient-to-t from-indigo-500 via-indigo-400 to-amber-300'
                : 'bg-slate-600/70'
            }`}
            style={{
              height: dynamicHeight,
              animation: isPlaying
                ? `pulseGlow 1.2s ease-in-out infinite alternate ${animationDelay}s`
                : 'none',
            }}
          />
        );
      })}
    </div>
  );
};
